<template>
    <header class="Nav">
        <div class="Nav-container">
            <ul class="Nav-list Nav-left">
                <li class="Nav-item">
                    <a :href="getLink('ABOUT')" >{{getLabel('NAV_ABOUT')}}</a>
                </li>
                <li class="Nav-item">
                    <a :href="getLink('NEWS')" >{{getLabel('NAV_NEWS')}}</a>
                </li>
                <li class="Nav-item">
                    <a :href="getLink('ACADEMIC')" >{{getLabel('NAV_ACADEMIC')}}</a>
                </li>
                <li class="Nav-item">
                    <a :href="getLink('CHARACTER')" >{{getLabel('NAV_CHARACTER')}}</a>
                </li>
            </ul>
            <ul class="Nav-list Nav-right">
                <li class="Nav-item">
                    <a :href="getLink('PUBLICATION')" >{{getLabel('NAV_PUBLICATION')}}</a>
                </li>
                <li class="Nav-item">
                    <a :href="getLink('IMAGE')" >{{getLabel('NAV_IMAGE')}}</a>
                </li>
                <li class="Nav-item">
                    <a :href="getLink('ANNOUNCEMENT')" >{{getLabel('NAV_ANNOUNCEMENT')}}</a>
                </li>
                <li class="Nav-item active">
                    <a href="" >{{getLabel('NAV_REGISTRATION')}}</a>
                </li>
            </ul>
            <div class="Nav-logo"></div>
            <div class="Nav-lang" v-if="language === 'zh'" @click="changeLanguage">EN</div>
            <div class="Nav-lang" v-if="language === 'en'" @click="changeLanguage">中</div>
            <a-dropdown class="Nav-user" placement="bottomCenter" v-if="currentUser && currentUser.user_id">
                <span class="Nav-userIcon"></span>
                <a-menu slot="overlay" style="text-align: center">
                    <a-menu-item class="Nav-pdfIcon" @click="openProtocol">
                        {{getLabel('TIP_PROTOCOL')}}
                        <div class="Nav-menuDivider"></div>
                    </a-menu-item>
                    <a-menu-item class="Nav-keyIcon" @click="changePassword">
                        {{getLabel('TIP_CHANGE_PASSWORD')}}
                        <div class="Nav-menuDivider"></div>
                    </a-menu-item>
                    <a-menu-item class="Nav-logoutIcon" @click="handleLogout">
                        {{getLabel('TIP_LOGOUT')}}
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
            <SideMenu v-if="currentUser && currentUser.user_id"/>
        </div>
    </header>
</template>

<script>
	import {mapState} from "vuex";
	import Language from '../util/language';
    import SideMenu from './SideMenu.vue';

	export default {
        components: {
            SideMenu
        },
		computed: {
			...mapState({
				language: state => state.main.language,
				currentUser: state => state.main.currentUser
			})
		},
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			},
            // 获取链接
            getLink: function (key) {
				const host = 'http://shanghaiforum.fudan.edu.cn';
			    const EN_Links = {
				    ABOUT: `${host}/forumen/d0/d4/c19062a184532/page.htm`,
				    NEWS: `${host}/forumen/19055/list.htm`,
				    ACADEMIC: `${host}/forumen/19056/list.htm`,
				    CHARACTER: `${host}/forumen/19057/list.htm`,
				    PUBLICATION: `${host}/forumen/19058/list.htm`,
				    IMAGE: `${host}/forumen/19059/list.htm`,
				    ANNOUNCEMENT: `${host}/forumen/19060/list.htm`
			    };
			    const ZH_Links = {
				    ABOUT: `${host}/19370/list.htm`,
				    NEWS: `${host}/19371/list.htm`,
				    ACADEMIC: `${host}/19372/list.htm`,
				    CHARACTER: `${host}/19373/list.htm`,
				    PUBLICATION: `${host}/19375/list.htm`,
				    IMAGE: `${host}/19377/list.htm`,
				    ANNOUNCEMENT: `${host}/19378/list.htm`
                };
                return this.language === 'zh' ? ZH_Links[key] : EN_Links[key]
            },
			changeLanguage: function () {
				const routerName = this.$route.name;
				let targetPath = this.$route.path;
				if (routerName.indexOf('en_') !== -1) {
					targetPath = targetPath.replace('/en', '');
                } else {
					targetPath = `/en${targetPath}`;
                }
                this.$router.push(targetPath);
			},
			handleLogout: function () {
				this.$store.dispatch('main/logout');
			},
			changePassword: function () {
				if (this.language === 'zh') {
					this.$router.push('/reset');
				} else {
					this.$router.push('/en/reset');
				}
			},
			openProtocol: function () {
                this.$store.commit('main/setProtocolModalStatus', true);
			}
		}
	};
</script>

<style lang="less">
    .Nav {
        background: #111D2D;
        position: fixed;
        width: 100%;
        height: 80px;
        margin-bottom: 90px;
        z-index: 100;
        &-container {
            position: relative;
            width: 1200px;
            height: 100%;
            margin: 0 auto;
        }
        &-list {
            position: relative;
            z-index: 10;
            height: 80px;
            bottom: 0;
            display: flex;
            justify-content: space-between;
        }
        &-left {
            width: 470px;
            float: left;
        }
        &-right {
            width: 415px;
            float: right;
            margin-right: 55px;
        }
        &-item {
            margin-top: 40px;
            margin-bottom: 1px;
            &:nth-last-child(1) {
                margin-right: 0;
            }
            a {
                color: #FFF;
                font-size: 14px;
            }
            &.active {
                border-bottom: 2px solid #FFF;
            }
            &:hover {
                border-bottom: 2px solid #FFF;
            }
        }
        &-logo {
            position: absolute;
            width: 276px;
            height: 276px;
            border-radius: 276px;
            background: url(../assets/img/logo.png) center bottom 35px no-repeat #111D2D;
            background-size: 147px 80px;
            top: -137px;
            left: 50%;
            transform: translateX(-50%);
        }
        &-lang {
            position: absolute;
            width: 26px;
            height: 26px;
            line-height: 26px;
            border: 1px solid #FFF;
            border-radius: 2px;
            text-align: center;
            color: #FFF;
            font-size: 14px;
            right: 0;
            top: 42px;
            cursor: pointer;
        }
        &-user {
            position: absolute;
            width: 26px;
            height: 31px;
            display: inline-block;
            right: -35px;
            top: 45px;
        }
        &-userIcon {
            cursor: pointer;
            background: url(../assets/img/user.png) center top no-repeat;
            background-size: 23px;
            &:hover {
                background: url(../assets/img/user_hover.png) center top no-repeat;
                background-size: 23px;
            }
        }
        &-pdfIcon {
            background: url(../assets/img/pdf.png) left 10px center no-repeat;
            background-size: 14px;
        }
        &-keyIcon {
            background: url(../assets/img/key.png) left 10px center no-repeat;
            background-size: 14px;
        }
        &-logoutIcon {
            background: url(../assets/img/logout.png) left 10px center no-repeat;
            background-size: 14px;
        }
        &-menuDivider {
            width: 80%;
            height: 1px;
            background: #DDD;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .ant-dropdown-menu-item {
        position: relative;
        color: #333;
        padding: 10px 35px;
        text-align: left;
    }
    .ant-dropdown-menu {
        border-radius: 10px;
    }
</style>

<style lang="less" scoped>

</style>
